// extracted by mini-css-extract-plugin
export default {"wrap":"MoreCategoriesButton_wrap__K3nxH","btn":"MoreCategoriesButton_btn__9SWF6","menu":"MoreCategoriesButton_menu__DvbEM","item":"MoreCategoriesButton_item__F4Mh3"};